// extracted by mini-css-extract-plugin
export default {"infoBlock":"InfoBlock_infoBlock__ULySU"};